<template>
  <div class="modal-backdrop" v-if="this.$store.state.modal.sendSms">
    <div class="modal-mask" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Отправить СМС ({{ this.userGet.full_name }}) - {{ this.userGet.phone }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="col-form-label">Сообщение</label>
              <textarea class="form-control" placeholder="Сообщение" v-model="sms.text" rows="4"/>
            </div>
            <div class="fs-12">
              <p class="link-info pointer" @click="selectText('Здравствуйте! Не можем до вас дозвониться и подтвердить заказ.')">
                Здравствуйте! Не можем до вас дозвониться и подтвердить заказ.
              </p>
              <p class="link-info pointer" @click="selectText('Здравствуйте! В связи с большими пробками на дорогах, ваш курьер задерживается по доставке на час, приносим извинение за всевозможные неудобства.')">
                Здравствуйте! В связи с большими пробками на дорогах, ваш курьер задерживается по доставке на час, приносим извинение за всевозможные неудобства.
              </p>
              <p class="link-info pointer" @click="selectText('Здравствуйте! Ваш курьер задерживается на 1 час, ожидали основные позиции по вашему заказу. Приносим извинение за доставленные неудобства.')">
                Здравствуйте! Ваш курьер задерживается на 1 час, ожидали основные позиции по вашему заказу. Приносим извинение за доставленные неудобства.
              </p>
              <p class="link-info pointer" @click="selectText('Здравствуйте! В вашем заказе не хватило позиции ...... Приносим извинение за всевозможные неудобства. Вынуждены были отменить товар.')">
                Здравствуйте! В вашем заказе не хватило позиции ...... Приносим извинение за всевозможные неудобства. Вынуждены были отменить товар.
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">Закрыть</button>
            <button type="button" class="btn btn-primary" @click="sendSms">Отправить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'send-sms',
  props: ['id'],
  data: function(){
    return{
      user: [],
      sms: {
        users_id: 0,
        text: '',
        score: null
      }
    }
  },
  computed: {
    ...mapGetters(['userGet']),
  },
  watch: {
    id: function (val) {
      if(val > 0){
        this.sms.users_id = val;
        this.getUser();
      }
    },
  },
  methods: {
    sendSms: function(){
      this.$store.dispatch('sendSms', this.sms).then(() => {
        this.sms.text = '';
        this.close();
      });
    },
    selectText: function(text){
      this.sms.text = text;
    },
    getUser: function(){
      this.$store.dispatch('getUser', this.sms.users_id);
    },
    close: function() {
      this.$store.state.modal.sendSms = false;
    },
  },
};
</script>
